module.exports = __webpack_public_path__ + "img/rate.e1f3c0f0.svg";